/**
 * @desc 调拨单临时处理
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(params: API.wms.allocationMaster.temp.Params, options?: any) {
  return updateResponse(
    http(URL + `/allocationMaster/temp`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
